import { render, staticRenderFns } from "./WenJuanPage.vue?vue&type=template&id=ad628296&scoped=true"
import script from "./WenJuanPage.vue?vue&type=script&lang=js"
export * from "./WenJuanPage.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/wenjuanPage.scss?vue&type=style&index=0&id=ad628296&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad628296",
  null
  
)

export default component.exports